import { capitalize } from 'lodash';

import { CJMError, CJMErrorDetail } from '@cjm/shared/types';

export const parseCJMErrorDetailPath = (path: string): string => {
	// Denis: If no path is provided, early return an empty string.
	if (!path) {
		return '';
	}

	// Denis: Return a capitalized, formatted path.
	return capitalize(
		path
			// Denis: Remove the decimals caused by arrays from the path.
			.replace(/\.\d+/g, '')
			// Denis: Convert remaining dots to spaces to make it more human-readable.
			.replace(/\./g, ' ')
			// Denis: Replace 'insz' with 'Rijksregisternummer' for better readability.
			.replace('insz', 'Rijksregisternummer')
	);
};

/**
 * formatCJMErrorDetails
 *
 * The formatCJMErrorDetails function formats the details of a CJMError object.
 *
 * @param cjmError{CJMError} - The CJMError object from the API.
 * @returns SafeHtml - The formatted error details.
 */
export const formatCJMErrorDetails = (cjmError: CJMError): string => {
	// Denis: If the targetObject is not an object or the cjmError does not contain any detail errors, early return an empty array.
	if (
		// Denis: Validate that the provided error has actual detail elements.
		!cjmError.detail ||
		!Array.isArray(cjmError.detail.elementen) ||
		cjmError.detail.elementen.length === 0
	) {
		return null;
	}

	// Denis: Map over the detail elements and return a string containing the message combined with the targetObjectValue;
	const errorList: Set<string> = cjmError.detail.elementen.reduce((acc: Set<string>, element: CJMErrorDetail) => {
		// Denis: Parse a message based on the `boodschap` property and the value.
		return acc.add(`<li>${parseCJMErrorDetailPath(element.pad)}: ${element.boodschap}</li>`);
	}, new Set([]));

	// Denis: Wrap the list items in an ul element and return the result as a string.
	return `<ul>${[...errorList].join('')}</ul>`;
};
